import { EnvironmentOutlined } from '@ant-design/icons';
import { Button, Divider, Popover, Spin } from 'antd';
import { FC, useState } from 'react';

import useSWRDeliverySpot from 'src/hooks/swr/useSWRDeliverySpot';
import useSWRStore from 'src/hooks/swr/useSWRStore';

interface AddressPopoverProps {
  deliverySpotId: string;
  storeId: string;
}

const AddressPopover: FC<AddressPopoverProps> = ({ deliverySpotId, storeId }) => {
  const [open, setOpen] = useState(false);

  const { deliverySpot, isLoading: isLoadingDeliverySpot } = useSWRDeliverySpot(open ? deliverySpotId : null);
  const { store, isLoading: isLoadingStore } = useSWRStore(open ? storeId : null);

  const isLoading = isLoadingDeliverySpot || isLoadingStore;

  const content = isLoading ? (
    <Spin size='small' />
  ) : (
    <div style={{ minWidth: 250 }}>
      {/* 배송지 정보 */}
      <div style={{ marginBottom: 12 }}>
        <div style={{ fontWeight: 600, marginBottom: 4 }}>배송지: {deliverySpot?.title || '-'}</div>
        <div style={{ fontSize: 14 }}>{deliverySpot?.jibunAddress || '-'}</div>
        <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 2 }}>{deliverySpot?.roadAddress || '-'}</div>
      </div>

      <Divider style={{ margin: '12px 0' }} />

      {/* 매장 정보 */}
      <div>
        <div style={{ fontWeight: 600, marginBottom: 4 }}>매장 주소: {store?.storeName || '-'}</div>
        <div style={{ fontSize: 14 }}>{store?.jibunAddress || store?.address || '-'}</div>
        <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 2 }}>{store?.roadAddress || '-'}</div>
        {store?.locationInfoUrl && (
          <div style={{ marginTop: 8 }}>
            <Button
              type='link'
              size='small'
              href={store.locationInfoUrl}
              target='_blank'
              rel='noopener noreferrer'
              style={{ padding: 0 }}
            >
              배송지 노션 링크
            </Button>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <Popover title='주소 정보' content={content} trigger='click' open={open} onOpenChange={setOpen}>
      <Button type='text' icon={<EnvironmentOutlined style={{ fontSize: 16 }} />} />
    </Popover>
  );
};

export default AddressPopover;
